import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/main/announcement-swiper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/main/footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/main/header.js");
